import {
  Button,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../utils/token";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AddTestPrepPackages({ serviceId }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [serviceList, setServiceList] = useState([]);
  const [serviceName, setServiceName] = useState(null);
  const [subServiceList, setSubSurviceList] = useState([]);
  const [subserviceName, setSubserviceName] = useState([]);
  const [subserviceIds, setSubserviceIds] = useState([]);
  const [testTypeList, setTestTypeList] = useState([]);
  const [testTypeName, setTestTypeName] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [subServicePrograms, setSubServicePrograms] = useState(null);
  const [programList, setProgramList] = useState(null);
  const [selectedClassList, setSelectedClassList] = useState([
    { id: 1, name: "Class 9", value: "class_9" },
    { id: 2, name: "Class 10", value: "class_10" },
    { id: 3, name: "Class 11", value: "class_11" },
    { id: 4, name: "Class 12", value: "class_12" },
  ]);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState(null);
  const [partnerUnivercity, setPartnerUniverCity] = useState(null);
  const [nonpartnerUnivercity, setNonPartnerUniverCity] = useState(null);
  const [isloading, setIsLoading] = useState(true);
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState(null);
  const [currency, setcurrency] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isTestivaMap, setIsTestivaMap] = useState(false);
  const [testivaPackages, setTestivaPackages] = useState([]);
  console.log("TP", testivaPackages);
  const [selectedTestivaPackage, setSelectedTestivaPackage] = useState(null);
  const [testivaParentPackageId, setTestivaParentPackageId] = useState(null);
  console.log("STP", selectedTestivaPackage);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const fileeredServis = data.filter(
            (i) => i.service_name !== "Undefined",
          );
          const selectedService = data.find((i) => i.id === serviceId);
          setServiceList(fileeredServis);
          setServiceName(selectedService);
          setValue("service_id", selectedService?.id || null);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlechangeService = (e, value) => {
    setSubserviceName([]);
    setSubserviceIds([]);
    setSubServicePrograms(null);
    setClassName(null);
    setServiceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);
    setTestTypeName(null);
    setValue("service_id", value?.id);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}advisordashboard/gettesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypeList(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();
          // const filteredTestType = data.filter(
          //   (i) => i.test_type_id === testTypeName?.id,
          // );
          setSubtestTypeList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [testTypeName]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/subservicesbytesttypeid/${testTypeName?.id}`,
        );
        if (response.ok) {
          const data = await response.json();

          setSubSurviceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [testTypeName]);

  const allSubServiceList =
    subServiceList.length > 1
      ? [{ name: "Select All" }, ...subServiceList]
      : subServiceList;

  const handlechangeSubservice = (e, value) => {
    setSubServicePrograms(null);
    setClassName(null);
    setSubserviceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);

    if (value.some((option) => option.name === "Select All")) {
      const subserviceIds = subServiceList.map((i) => i.id);
      setSubserviceName(subServiceList);
      setSubserviceIds(subserviceIds);
      setValue("sub_service_id", subserviceIds);
    } else {
      const subserviceIds = value.map((i) => i.id);
      setSubserviceIds(subserviceIds);

      setValue("sub_service_id", subserviceIds);
    }
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const filteredcountry = data.filter(
          (i) => i.country_name === "India" || i.country_name === "Nepal",
        );
        setCountryList(filteredcountry);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  const handleCountryChange = (e, value) => {
    setBranchName([]);
    setValue("branch_id", []);
    setCountryName(value);

    setValue("country_id", value?.id);
    setcurrency(value?.currency_code);
    setValue("currency", value?.currency_code);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}branch`)
      .then((response) => response.json())
      .then((data) => {
        const flteredBranch = data.filter(
          (i) => i.country_id === countryName?.id,
        );
        setBranchList(flteredBranch);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, [countryName]);

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];
  const handlebranchChange = (e, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      const selectedBranch = branchList.map((i) => i.id);
      setBranchName(branchList);
      setValue("branch_id", selectedBranch);
    } else {
      setBranchName(value);
      setValue(
        "branch_id",
        value.map((i) => i.id),
      );
    }
  };

  useEffect(() => {
    if (subServicePrograms?.name === "Accelerated SUAP (for 11-12 class)") {
      const filteredClass = selectedClassList.filter(
        (i) => !["class_9", "class_10"].includes(i.value),
      );
      setClassList(filteredClass);
    } else {
      setClassList(selectedClassList);
    }
  }, [subServicePrograms]);

  useEffect(() => {
    const fetchTestivaPackages = async () => {
      if (!isTestivaMap) return;

      const testivaSubTestTypeId = subtestType?.testiva_sub_test_type_id;

      if (!testivaSubTestTypeId) return;

      try {
        const token = getTokenOrLogout();
        if (!token) return;

        const response = await fetch(
          `${API_ENDPOINT}testiva-integration/get-package/${testivaSubTestTypeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = await response.json();

        console.log("result", result);

        if (response.ok) {
          // Store parent package ID
          const parentPackageId = result?.[0]?.id || null;

          setTestivaParentPackageId(parentPackageId);

          console.log("Parent Package ID:", parentPackageId);

          // Store all packages
          const packages =
            result?.flatMap((item) => item?.packages || []) || [];

          setTestivaPackages(packages);
        }
      } catch (error) {
        console.error("Error fetching Testiva packages", error);
      }
    };

    fetchTestivaPackages();
  }, [isTestivaMap, subtestType]);

  const handleChangeClass = (e, value) => {
    setClassName(value);
    setValue("scholars_class", value?.value);
  };

  const onSubmit = async (data) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        ...data,
        user_id: parseInt(userId),
        duration: parseInt(data.duration, 10), // ensure it's an integer
        original_price: parseInt(data.original_price, 10),
        discounted_price: parseInt(data.discounted_price, 10),
        non_partner_university: parseInt(data.non_partner_university, 10),
        partner_university: parseInt(data.partner_university, 10),
        module_reading: data.module_reading,
        module_listining: data.module_listening,
        module_writing: data.module_writing,
        module_speaking: data.module_speaking,

        question_reading: data.question_reading,
        question_listining: data.question_listening,
        question_writing: data.question_writing,
        question_speaking: data.question_speaking,

        is_testiva_map: isTestivaMap ? 1 : 0,
        testiva_package_id: selectedTestivaPackage?.package_id || null,
        testiva_parent_package_id: testivaParentPackageId || null,
      };
      console.log("RD", requestData);
      const response = await fetch(`${API_ENDPOINT}package`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      console.log("result", result);
      if (response.ok) {
        showSnackbar("Packages Added Successfully", "success");

        // setTimeout(() => {
        //   window.location.reload();
        // }, 1500);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else if (response.status === 409) {
        showSnackbar("Duplicate Package Name", "error");
      } else {
        showSnackbar(result.error, "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };

  return (
    <>
      {isloading ? (
        <Typography variant="h4">Loading...</Typography>
      ) : (
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.service_id)}>
              <Typography variant="h5" mb={0.5}>
                Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="service_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    disableClearable
                    size="small"
                    value={serviceName}
                    onChange={handlechangeService}
                    options={serviceList}
                    getOptionLabel={(option) => option.service_name}
                    tooltipContent={(option) => option.service_name}
                    error={Boolean(errors.service_id)}
                    helperText={
                      errors.service_id && errors?.service_id?.message
                    }
                    readOnly
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.test_type)}>
              <Typography variant="h5" mb={0.5}>
                Test Type{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="test_type"
                control={control}
                rules={{
                  required:
                    serviceName?.id === 1 ? "This is required field" : false,
                }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={testTypeName}
                    onChange={(e, value) => {
                      setTestTypeName(value);
                      setValue("test_type", value?.id || null);
                    }}
                    options={testTypeList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    error={Boolean(errors.test_type)}
                    helperText={errors.test_type && errors?.test_type?.message}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.sub_service_id)}>
              <Typography variant="h5" mb={0.5}>
                Sub Service{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="sub_service_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    multiple
                    disableClearable
                    noOptionsText={
                      testTypeName === null
                        ? "Select Test Type First"
                        : testTypeName !== null && subTestTypeList?.length === 0
                          ? "No Sub Test Type Available"
                          : ""
                    }
                    value={subserviceName}
                    onChange={handlechangeSubservice}
                    options={allSubServiceList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                    error={Boolean(errors.sub_service_id)}
                    helperText={
                      errors.sub_service_id && errors?.sub_service_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
          {console.log("subTestTypeList", subTestTypeList)}
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.test_type)}>
              <Typography variant="h5" mb={0.5}>
                Sub Test Type{" "}
              </Typography>
              <Controller
                name="sub_test_type_id"
                control={control}
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={subtestType}
                    noOptionsText={
                      testTypeName === null
                        ? "Select Test Type First"
                        : testTypeName !== null && subTestTypeList?.length === 0
                          ? "No Test Type Available"
                          : ""
                    }
                    onChange={(e, value) => {
                      setsubtestType(value);
                      setValue("sub_test_type_id", value?.id || null);

                      // Reset Testiva mapping when Sub Test Type changes
                      setIsTestivaMap(false);
                      setValue("is_testiva_map", 0);

                      setSelectedTestivaPackage(null);
                      setValue("testiva_package_id", null);

                      setTestivaPackages([]);
                    }}
                    options={subTestTypeList}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isTestivaMap}
                  onChange={(e) => {
                    setIsTestivaMap(e.target.checked);
                    setValue("is_testiva_map", e.target.checked ? 1 : 0);

                    if (!e.target.checked) {
                      setSelectedTestivaPackage(null);
                      setValue("testiva_package_id", null);
                    }
                  }}
                />
              }
              label="Map with Testiva Package"
            />
          </Grid>

          {isTestivaMap && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="h5" mb={0.5}>
                  Testiva Package
                </Typography>

                <Controller
                  name="testiva_package_id"
                  control={control}
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      value={selectedTestivaPackage}
                      onChange={(e, value) => {
                        setSelectedTestivaPackage(value);
                        setValue(
                          "testiva_package_id",
                          value?.package_id || null,
                        );
                      }}
                      options={testivaPackages}
                      getOptionLabel={(option) =>
                        option.package_name || option.name
                      }
                      tooltipContent={(option) =>
                        option.package_name || option.name
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.package_name)}>
              <Typography variant="h5" mb={0.5}>
                Package Name{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="package_name"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.package_name)}
                    helperText={
                      errors.package_name && errors?.package_name?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h5" mb={0.5}>
                Session
                {/* <span style={{ color: "red", fontSize: "0.7rem" }}>*</span> */}
              </Typography>
              <Controller
                name="duration"
                control={control}
                // rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.country_id)}>
              <Typography variant="h5" mb={0.5}>
                Country{" "}
              </Typography>
              <Controller
                name="country_id"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    disableClearable
                    value={countryName}
                    onChange={handleCountryChange}
                    options={countryList}
                    getOptionLabel={(option) => option.country_name}
                    tooltipContent={(option) => option.country_name}
                    error={Boolean(errors.country_id)}
                    helperText={
                      errors.country_id && errors?.country_id?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          {countryName && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.branch_id)}>
                <Typography variant="h5" mb={0.5}>
                  Currency
                </Typography>
                <Controller
                  name="currency"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      fullWidth
                      size="normal"
                      multiple
                      value={currency}
                      InputProps={{
                        readOnly: true,
                        style: { borderRadius: "10px" },
                      }}
                      error={Boolean(errors.currency)}
                      helperText={errors.currency && errors?.currency?.message}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          {countryName && (
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.branch_id)}>
                <Typography variant="h5" mb={0.5}>
                  Branch
                </Typography>
                <Controller
                  name="branch_id"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      multiple
                      value={branchName}
                      onChange={handlebranchChange}
                      options={allBranchList}
                      getOptionLabel={(option) => option.branch_name}
                      tooltipContent={(option) => option.branch_name}
                      error={Boolean(errors.branch_id)}
                      helperText={
                        errors.branch_id && errors?.branch_id?.message
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.original_price)}>
              <Typography variant="h5" mb={0.5}>
                Original Price{" "}
                <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
              </Typography>
              <Controller
                name="original_price"
                control={control}
                rules={{ required: "This is required field" }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    type="number"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.original_price)}
                    helperText={
                      errors.original_price && errors?.original_price?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.discounted_price)}>
              <Typography variant="h5" mb={0.5}>
                Discounted Price{" "}
              </Typography>
              <Controller
                name="discounted_price"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    size="normal"
                    type="number"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth error={Boolean(errors.payable_installment)}>
              <Typography variant="h5" mb={0.5}>
                Payable Installments{" "}
              </Typography>
              <Controller
                name="payable_installment"
                control={control}
                // rules={{ required: true }} // Add your validation rules here
                render={({ field }) => (
                  <Select
                    {...field}
                    size="normal"
                    style={{ borderRadius: "10px" }}
                  >
                    <MenuItem value={1}>No installments</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h5">
                Number of Mock Tests
              </Typography>
              <Controller
                name="mock_tests"
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid> */}

          {/* <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h5">
                Number of Module-Wise Tests
              </Typography>
              <Controller
                name="module_wise_questions"
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h5">
                Number of Question-Wise Tests (PTE)
              </Typography>
              <Controller
                name="question_wise_questions"
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    fullWidth
                    type="number"
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid> */}

          {/* ================= MOCK TESTS ================= */}
          {/* <Grid item xs={12}>
          <Typography variant="h5">Mock Tests</Typography>
          <Divider />
        </Grid>

        {["reading", "listening", "writing", "speaking"].map(skill => (
          <Grid item xs={12} md={3} key={`mock_${skill}`}>
            <FormControl fullWidth>
              <Typography>{skill.toUpperCase()}</Typography>
              <Controller
                name={`mock_${skill}`}
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp {...field} type="number"  size="normal" fullWidth />
                )}
              />
            </FormControl>
          </Grid>
        ))} */}

          {/* ================= MODULE-WISE ================= */}
          {/* <Grid item xs={12}>
          <Typography variant="h5">Module-Wise Tests</Typography>
          <Divider />
        </Grid>

        {["reading", "listening", "writing", "speaking"].map(skill => (
          <Grid item xs={12} md={3} key={`module_${skill}`}>
            <FormControl fullWidth>
              <Typography>{skill.toUpperCase()}</Typography>
              <Controller
                name={`module_${skill}`}
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp {...field} type="number"  size="normal" fullWidth />
                )}
              />
            </FormControl>
          </Grid>
        ))} */}

          {/* ================= QUESTION-WISE (PTE) ================= */}
          {/* <Grid item xs={12}>
            <Typography variant="h5">Question-Wise Tests (PTE)</Typography>
            <Divider />
          </Grid>

          {["reading", "listening", "writing", "speaking"].map((skill) => (
            <Grid item xs={12} md={3} key={`question_${skill}`}>
              <FormControl fullWidth>
                <Typography>{skill.toUpperCase()}</Typography>
                <Controller
                  name={`question_${skill}`}
                  control={control}
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      type="number"
                      size="normal"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </Grid>
          ))} */}

          <Grid item xs={12} sm={12} md={12}>
            <FormControl fullWidth error={Boolean(errors.description)}>
              <Typography variant="h5">Description </Typography>
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    multiline
                    rows={6}
                    size="normal"
                    InputProps={{
                      style: {
                        borderRadius: "10px",
                      },
                    }}
                    error={Boolean(errors.description)}
                    helperText={
                      errors.description && errors?.description?.message
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} textAlign="end">
            <Button
              variant="contained"
              size="medium"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
